import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto, seleccionarCampo
} from '../../util/varios';


import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import { AgregarCuentasGastos } from './modalAgregarCuentasGastos';


function TablaCodificacion(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sec', textAlign: 'center' },
        { id: '2', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Prog', textAlign: 'center' },
        { id: '3', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Spro', textAlign: 'center' },
        { id: '4', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Proy', textAlign: 'center' },
        { id: '5', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Act', textAlign: 'center' },
        { id: '6', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Par', textAlign: 'center' },
        { id: '7', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Gen', textAlign: 'center' },
        { id: '8', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Esp', textAlign: 'center' },
        { id: '9', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sub', textAlign: 'center' },
        { id: '10', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Ord', textAlign: 'center' },
        { id: '11', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
        { id: '13', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Bs.', textAlign: 'center' },
        { id: '14', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Presupuesto Ejercicio', textAlign: 'center' },
        { id: '15', width:'800px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Disponibilidad', textAlign: 'center' },
        { id: '16', width:'8px' , backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [iva, setIva] = useState(0);
    const [operacion, setOperacion] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [habiPorce, setHabiporce] = useState(false);
    const txtMonto = useRef([]);
    const txtMontoTotal = useRef();
    const txtIva = useRef();
    const txtMontoiva = useRef();
    const txtBtnIncluir = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }

    const seleccionarIva = (id) => {

        let campos = "*"
        let nomtab = "iva";
        let nomid = "idiva";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idiva > 0) {
                    setIva(response.data.porcentaje);
                } else {
                    setIva(0.00);
                }

            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    useEffect(() => {
        seleccionarIva(1);
    }, []);


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {
            if (props.idprov === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe primero seleccionar un proveedor', icono: 'informacion' });
                return;
            }
            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        } if (ope === 3) {

        }

    }

    useEffect(() => {

        if (props.datarecords && props.datarecords.length > 0) {

            if (props.operacion === 3) {

                var data = [...props.datarecords];
                var datos = [];

                for (let i = 0; i < data.length; i++) {

                    datos.push({
                        idcuenta: data[i].idcuenta,
                        auxiliar: data[i].auxiliar,
                        monto: data[i].monto,
                        idcat: data[i].idcategoria,
                        idpuc: data[i].idpuc,

                    });

                }
                props.data(datos);
            }


        }

    }, [props.datarecords]);

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);
        for (let i = 0; i < records.length; i++) {
            for (let z = 0; z < datos.length; z++) {
                if (records[i].idcuenta === datos[z].idcuenta) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Tipo de Compromiso', icono: 'informacion' });
                }
            }

        }
        let data = [...records];


        for (let i = 0; i < datos.length; i++) {

            data.push({
                uno: datos[i].uno,
                dos: datos[i].dos,
                tres: datos[i].tres,
                cuatro: datos[i].cuatro,
                cinco: datos[i].cinco,
                seis: datos[i].seis,
                siete: datos[i].siete,
                ocho: datos[i].ocho,
                nueve: datos[i].nueve,
                auxiliar: datos[i].auxiliar,
                descripcion: datos[i].descripcion,
                montoinicial: datos[i].montoinicial,
                disponible: datos[i].disponible,
                monto: datos[i].monto,
                idcuenta: datos[i].idcuenta,
                idcat: datos[i].idcat,
                idpuc: datos[i].idpuc,
                descripcionaux: datos[i].descripcionaux,
                descripcat: '',
                descrippuc: '',
                //idmovimiento: data[i].idmovimiento,

            });

        }

        let total = 0.00;
        let montoiva = 0.00;

        for (let e = 0; e < data.length; e++) {
            total = parseFloat(total) + parseFloat(data[e].monto);
        }

        //montoiva = total * iva / 100;

        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        if (props.tipo === 11 || props.tipo === 12) {
            if (props.exento === false) {
                montoiva = Math.round(parseFloat(total) * parseFloat(iva) / (100 + parseFloat(iva)) * Math.pow(10, 4)) / Math.pow(10, 4);
                //montoiva = Math.round(parseFloat(total) * parseFloat(iva) / 100 * Math.pow(10, 4)) / Math.pow(10, 4);
                txtMontoiva.current.value = formatMoneda(montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            } else {
                txtMontoiva.current.value = '0,00';
                txtIva.current.value = '0,00';
            }
        }

        setRecords(data);
        props.data(data, montoiva);
    }

    useEffect(() => {
        txtMontoTotal.current.value = '0,00';
        txtMontoiva.current.value = '0,00';
        if (props.tipo === 5 || props.tipo === 7 || props.tipo === 11 || props.tipo === 13 || props.tipo === 23 || props.tipo === 24 || props.tipo === 26) {
            setHabiporce(false);
            txtIva.current.value = '0,00'
            if (props.datarecords && props.datarecords.length > 0) {
                txtMontoiva.current.value = formatMoneda(props.datarecords[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            }

        } else if (props.tipo === 12) {
            if (props.exento === false) {
                setHabiporce(true);
                txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            } else {
                setHabiporce(false);
                txtIva.current.value = '0,00'
                //setIva(0.00);
            }

        }
        if (props.datarecords && props.datarecords.length > 0 && props.datarecords[0].idcuenta > 0) {

            var data = [...props.datarecords];
            var datos = [];
            setHabiporce(false);
            txtIva.current.value = '0,00'

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    uno: data[i].cuenta.substring(0, 2),
                    dos: data[i].cuenta.substring(2, 4),
                    tres: data[i].cuenta.substring(4, 6),
                    cuatro: data[i].cuenta.substring(6, 8),
                    cinco: data[i].cuenta.substring(8, 10),
                    seis: data[i].cuenta.substring(10, 13),
                    siete: data[i].cuenta.substring(13, 15),
                    ocho: data[i].cuenta.substring(15, 17),
                    nueve: data[i].cuenta.substring(17, 19),
                    auxiliar: data[i].auxiliar,
                    descripcat: data[i].descripcat,
                    descrippuc: data[i].descrippuc,
                    monto: data[i].monto,
                    montoinicial: data[i].montoinicial,
                    disponible: data[i].disponibilidad,
                    descripcionaux: data[i].descripcionaux,
                    idcat: data[i].idcategoria,
                    idpuc: data[i].idpuc,
                    idcuenta: data[i].idcuenta,
                    idmovimiento: data[i].idmovimiento,

                });

            }

            let total = 0.00;

            for (let e = 0; e < data.length; e++) {
                total = parseFloat(total) + parseFloat(data[e].monto);
            }

            txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            txtMontoiva.current.value = formatMoneda(props.datarecords[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords(datos);
            props.data(datos, props.datarecords[0].montoiva);
        } else {
            setRecords([]);
        }

    }, [props.datarecords, props.exento]);

    const eliminarPresupuesto = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];
        var blanquea = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idcuenta !== datos[i].idcuenta) {
                elementos.push(datos[i]);
            }

        }

        let total = 0.00;
        let montoiva = 0.00;
        for (let e = 0; e < elementos.length; e++) {
            total = parseFloat(total) + parseFloat(elementos[e].monto);
        }
        //montoiva = total * iva / 100 + iva;
        montoiva = Math.round(parseFloat(total) * parseFloat(iva) / (100 + parseFloat(iva)) * Math.pow(10, 4)) / Math.pow(10, 4);

        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        txtMontoiva.current.value = formatMoneda(montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);

        blanquea.push({

            uno: "",
            dos: "",
            tres: "",
            cuatro: "",
            descripcion: "",
            monto: ""

        });

        setRecords(elementos);
        props.data(elementos);
    }

    const validarMonto = (index) => (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '1,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }
            if (event.target.id === 'monto') {

                let data = [...records];

                var monto = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));

                data[index].monto = monto;

                let total = 0.00;

                for (let i = 0; i < data.length; i++) {
                    total = parseFloat(total) + parseFloat(data[i].monto);
                }

                txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                setRecords(data);
                props.data(data);

            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleCloseSi = () => {

        setActivate(false);

    };

    const handleInputMontoChange = (event) => {

        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.id === 'porceiva') {

                let montoiva = 0.00;
                let porce = parseFloat(txtIva.current.value.trim().replace(/\./g, '').replace(',', '.'));
                setIva(porce);
                let total = parseFloat(txtMontoTotal.current.value.trim().replace(/\./g, '').replace(',', '.'));
                montoiva = Math.round(parseFloat(total) * parseFloat(porce) / (100 + parseFloat(porce)) * Math.pow(10, 4)) / Math.pow(10, 4);
                txtMontoiva.current.value = formatMoneda(montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                //setRecords(data);
                props.data(records, montoiva);
            }
            if (event.which === 13) {
                if (event.target.id === 'porceiva') {
                    //btnSalir.current.focus();
                } else if (event.target.id === 'inputReintegro' || event.target.id === 'inputRetenciones') {
                    //btnProcesar.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };


    return (
        <div>

            <AgregarCuentasGastos
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                esaumento={false}
                cuentas={records}
                montocompro={props.nmonacompro}
                total={txtMontoTotal.current ? parseFloat(txtMontoTotal.current.value.replace('.', '').replace(',', '.')) : 0.00}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

            <Dimmer active={activate} inverted>

            </Dimmer>

            <div className="row col-md-12 mx-auto m-0">

                <div className="col-md-11 m-0 px-0 mb-1">
                    <TblContainer container={{ height: 130, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px' }}>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: "10px" }}>{item.uno}</td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '10px' }}>{item.dos}</td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: "10px" }}>{item.tres} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: "10px" }}>{item.cuatro} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '20px' }}>{item.cinco} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '10px' }}>{item.seis} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '10px' }}>{item.siete} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '10px' }}>{item.ocho} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '10px' }}>{item.nueve} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "center", width: '20px' }}>{item.auxiliar} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "justify", width: '150px' }}>{item.descripcionaux !== '' ? item.descripcionaux : item.descripcat !== '' ? item.descripcat + '(' + item.descrippuc + ')' : item.descripcion} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "right", width: '50px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "right", width: '50px' }}>{formatMoneda(item.montoinicial.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "11px", textAlign: "right", width: '50px' }}>{formatMoneda(item.disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ textAlign: "center", width: '40px' }}>
                                            <button onClick={eliminarPresupuesto(item)} style={{ visibility: (props.operacion === 4 || props.operacion === 2 || props.operacion === 5) && 'collapse' }} disabled={props.validaboton} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>
                <div className='col-md-1 m-auto mb-1'>

                    <div className="col-md-12">
                        <button onClick={opciones(1, '')} disabled={props.validaboton} ref={txtBtnIncluir} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"><small> INCLUIR</small></i> </button>
                    </div>

                </div>
                <div className='col-md-11 m-0 px-0  mb-1'>
                    <div className='col-sm-3 ml-auto px-0'>
                        <div className="input-group input-group-sm m-0 w-100">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto Compromiso:</label>
                            <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoTotal} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                        </div>
                    </div>
                    <div className='col-sm-3 ml-auto px-0'>
                        <div className="input-group input-group-sm m-0 w-100">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Porcentaje IVA:</label>
                            <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={!habiPorce} ref={txtIva} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="porceiva" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                        </div>
                    </div>
                    <div className='col-sm-3 ml-auto px-0'>
                        <div className="input-group input-group-sm m-0 w-100">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto IVA:</label>
                            <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoiva} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );

}

export default TablaCodificacion;
